/**
 * Русские склонения для счётчиков в интерфейсе.
 *
 * pluralRu(5, ['чек', 'чека', 'чеков']) -> 'чеков'
 * pluralRu(1, ['документ', 'документа', 'документов']) -> 'документ'
 *
 * Правила: 1, 21, 31… — первая форма; 2–4, 22–24… — вторая;
 * 0, 5–20, 11–14, 25–30… — третья.
 */
export function pluralRu(n: number, forms: [string, string, string]): string {
  const abs = Math.abs(Math.trunc(n))
  const mod100 = abs % 100
  const mod10 = abs % 10
  if (mod100 >= 11 && mod100 <= 14) return forms[2]
  if (mod10 === 1) return forms[0]
  if (mod10 >= 2 && mod10 <= 4) return forms[1]
  return forms[2]
}

/** Готовое словосочетание: pluralRuCount(3, ['чек', 'чека', 'чеков']) -> '3 чека'. */
export function pluralRuCount(n: number, forms: [string, string, string]): string {
  return `${n} ${pluralRu(n, forms)}`
}
